/* fieldset.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._43nrzT2ADO%7Bmargin-block-start%3Avar(--ds-space-100%2C8px)%7D");
import { type ReactNode } from 'react';
import { Legend } from './legend';
interface FieldsetProps {
  /**
   * Content to render in the fieldset.
   */
  children: ReactNode;
  /**
   * Label describing the contents of the fieldset.
   */
  legend?: ReactNode;
}
const fieldSetStyles = null;

/**
 * __Fieldset__
 *
 * A fieldset groups a number of fields together. For example, when multiple CheckboxFields share the same name,
 * a fieldset can be used to group them together. This makes the form more accessible.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 */
export const Fieldset = ({
  children,
  legend
}: FieldsetProps): JSX.Element => {
  return <fieldset className={ax(["_43nrzT2ADO"])}>
			{legend && <Legend>{legend}</Legend>}
			{children}
		</fieldset>;
};